import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import MainSidebar from '../../components/MainSidebar'
import MainHeaderBar from '../../components/MainHeaderBar'
import { inject, observer } from 'mobx-react'
import SuperAdminPageSidebar from '../../components/SuperAdminPageSidebar'
import SidebarCollapseToggle from '../SidebarCollapseToggle'
import styles from './DashboardLayout.module.css'
import { useHistory } from 'react-router-dom'
import { MenuUnfoldOutlined } from '@ant-design/icons'

const STORAGE_KEY = 'isCollapsedSidebar'

const DashboardLayout = ({ ...props }) => {
  const { children, title, commonStore } = props

  const history = useHistory()

  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      return stored ? JSON.parse(stored) : false
    } catch {
      return false
    }
  })

  useEffect(() => {
    commonStore.setCollapsedMenu(!isCollapsed)
  }, [commonStore, isCollapsed])

  useEffect(() => {
    const currentPath = window.location.pathname

    if (
      currentPath !== '/report' &&
      currentPath !== '/report/periodic' &&
      currentPath !== '/report/extraordinary'
    ) {
      sessionStorage.removeItem('selectedYear')
    }
  }, [window.location.pathname])

  const handleCollapseChange = next => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    setIsCollapsed(next)
    commonStore.setCollapsedMenu(!next)
  }

  const handleExpandFromHeader = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(false))
    setIsCollapsed(false)
    commonStore.setCollapsedMenu(true)
  }

  return (
    <>
      <div className={styles.mainLayoutWrapper}>
        <aside
          className={`${styles.navigationMenu} ${
            isCollapsed ? styles.navigationMenuCollapsed : ''
          }`}>
          <figure
            className="logoWrapper"
            onClick={() => history.push('/dashboard')}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/photos/portal_logo_white.png`}
              alt="VIMC logo"
              width={isCollapsed ? 40 : 99}
            />
          </figure>

          <nav role="navigation">
            <div>
              {props.isSuperAdminPage ? (
                <SuperAdminPageSidebar />
              ) : (
                <MainSidebar />
              )}
            </div>
          </nav>

          <SidebarCollapseToggle
            isCollapsed={isCollapsed}
            onChange={handleCollapseChange}
          />
        </aside>

        <div className={styles.mainContentWrapper}>
          <header className="navigationTabBar">
            {/* {isCollapsed && (
              <button
                className={styles.headerToggleBtn}
                onClick={handleExpandFromHeader}
                title="Mở rộng sidebar">
                <MenuUnfoldOutlined />
              </button>
            )} */}
            <MainHeaderBar title={title} />
          </header>
          <div className="contentContainer">{children}</div>
        </div>
      </div>
    </>
  )
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
}

export default inject('commonStore')(observer(DashboardLayout))
